<template>
  <div class="mparE">
    <div id="allmap" ref="allmap" class="newmpar"></div>
    <div class="info">点击地图上的点标记，打开所添加的自定义信息窗体</div>
  </div>
</template>

<script>
import { AlistprovinceMap,homeGetUidIn } from "@/network/index";
export default {
  data() {
    return {
      map: null,
    };
  },
  created() {},
  mounted() {
    // this.marpList();
    this.dataRewues();
  },
  methods: {
    async dataRewues() {
      const { code, data, msg } = await AlistprovinceMap();
      // console.log(data);

      let naaet = data;
      // naaet.forEach((item) => {
      //   if (item.data != "") {
      //     item.data.channelinfo.forEach((element) => {
      //       element.userName = item.name;
      //     });
      //   }
      // });

      // if (code) {
      this.marpList(naaet);
    },
   marpList(mapList) {
      this.map = new BMap.Map(this.$refs.allmap);
      this.map.addControl(
        new BMap.MapTypeControl({
          mapTypes: [BMAP_NORMAL_MAP, BMAP_HYBRID_MAP],
        })
      );
      // 地图标点
      var info = document.createElement("div");
      var middle = document.createElement("div");
      mapList.forEach((element) => {
        var point = new BMap.Point(element.longitude, element.latitude);
        this.map.centerAndZoom(point, 0);

        var marker = new BMap.Marker(point); // 创建标注

        this.map.addOverlay(marker); // 将标注添加到地图中
        // console.log(element);
        
        marker.channeldata = element;
        marker.addEventListener("click",async (e) => {
          let arrinfo = e.target.channeldata;
          // console.log(arrinfo);
          let gateway_uuid = arrinfo.uuid
        const {code,data} = await homeGetUidIn(gateway_uuid)
        // console.log(data);
        let arr = data.channelinfo
          
          if (arr != undefined) {
            let net = "";
            for (var i = 0; i < arr.length; i++) {
              let it = i + 1;
              let arrs = it * 50;
              var opts = {
                width: 200, // 信息窗口宽度
                height: arrs, // 信息窗口高度
                title:arrinfo.name, // 信息窗口标题
              };

              net += `<ul><li style="color:${
                arr[i].channelflag == 0
                  ? "#00c600"
                  : arr[i].channelflag == 1
                  ? "#0080ff"
                  : "#ff5353"
              }">${
                this.lang_file == "zh-cn"
                  ? arr[i].unittype
                  : arr[i].unittype_en + ":"
              }${arr[i].channeldata}${
                this.lang_file == "zh-cn" ? arr[i].unit : arr[i].unit_en
              }</li> </ul>`;
              info.appendChild(middle);

              var infoWindow = new BMap.InfoWindow(info, opts); //创建信息窗口对象

              this.map.openInfoWindow(infoWindow, point); //开启信息窗口
            }
            middle.innerHTML = net;
          } else {
            this.$message.error("没有数据");
          }
        });
      });

      this.map.enableScrollWheelZoom(true); //开启鼠标缩放功能
      let that = this;
      // 定位功能
      var geolocation = new BMap.Geolocation();
      geolocation.getCurrentPosition(function (r) {
        if (this.getStatus() == BMAP_STATUS_SUCCESS) {
          var point = new BMap.Point(r.point.lng, r.point.lat);
          that.map.centerAndZoom(point, 2);
          var markeren = new BMap.Marker(point); // 创建标注
          // that.map.addOverlay(markeren); // 将标注添加到地图中
          // markeren.setAnimation(BMAP_ANIMATION_BOUNCE); //跳动的动画

          // var opts = {
          //   position: point, // 指定文本标注所在的地理位置
          //   offset: new BMap.Size(-50, -60), //设置文本偏移量
          // };
          // var label = new BMap.Label(
          //   `当前位置:${r.address.city}-${r.address.province}`,
          //   opts
          // ); // 创建文本标注对象
          // label.setStyle({
          //   color: "red",
          //   fontSize: "12px",
          //   height: "20px",
          //   lineHeight: "20px",
          //   fontFamily: "微软雅黑",
          // });
          // that.map.addOverlay(label);
        } else {
          alert("failed" + this.getStatus() + "定位失败");
        }
      });
    },
  },
};
</script>

<style  >
.mparE {
  width: 100%;
  height: 100%;
}
.newmpar {
  width: 100%;
  height: 100%;
  position: relative;
}
.content-window-card {
  position: relative;
  box-shadow: none;
  bottom: 0;
  left: 0;
  width: auto;
  padding: 0;
}

.content-window-card p {
  height: 2rem;
}

.custom-info {
  border: solid 1px silver;
}

div.info-top {
  position: relative;
  background: none repeat scroll 0 0 #f9f9f9;
  border-bottom: 1px solid #ccc;
  border-radius: 5px 5px 0 0;
}

div.info-top div {
  display: inline-block;
  color: #333333;
  font-size: 14px;
  font-weight: bold;
  line-height: 31px;
  padding: 0 10px;
}

div.info-top img {
  position: absolute;
  top: 10px;
  right: 10px;
  transition-duration: 0.25s;
}

div.info-top img:hover {
  box-shadow: 0px 0px 5px #000;
}

div.info-middle {
  font-size: 12px;
  padding: 10px 6px;
  line-height: 20px;
}

div.info-bottom {
  height: 0px;
  width: 100%;
  clear: both;
  text-align: center;
}

div.info-bottom img {
  position: relative;
  z-index: 104;
}

span {
  margin-left: 5px;
  font-size: 11px;
}

.info-middle img {
  float: left;
  margin-right: 6px;
}
</style>
